import { IDeliveryNote } from 'commons/types';

import { SwipeRxWmsApi } from '../resources';
import { SwipeRxAPIResources } from '../resources/types';

export interface DeliveryNoteListResponse {
  data: IDeliveryNote[];
  total: number;
}

export interface DeliveryNotePriorityListResponse {
  data: string[];
}

class SwipeRxWmsApiDeliveryNote extends SwipeRxWmsApi {
  private readonly basePath: string;

  constructor() {
    super(SwipeRxAPIResources.DELIVERY_NOTE);
    this.basePath = `/${this.apiResource}`;
  }

  async getDeliveryNoteList(
    queries: Record<string, string>,
  ): Promise<DeliveryNoteListResponse> {
    const result = await this.get(this.basePath, queries);
    const resultData = result.data;
    if (resultData) {
      return {
        data: resultData.data as IDeliveryNote[],
        total: (resultData.count as number) ?? 0,
      };
    }
    return { data: [], total: 0 };
  }

  async printDeliveryNote(awbNumber: string): Promise<void> {
    await this.patch(`${this.basePath}/${awbNumber}/print`, {});
  }

  async getDeliveryNoteByAwbNumber(awbNumber: string): Promise<IDeliveryNote> {
    const result = await this.get(`${this.basePath}/${awbNumber}`);
    return result.data as IDeliveryNote;
  }

  async getPriorityList(): Promise<string[]> {
    const result = await this.get(`${this.basePath}/priority-list`);
    return (result?.data as string[]) ?? [];
  }

  async getDeliveryNoteByPoNumber(
    poNumber: string,
  ): Promise<IDeliveryNote | null> {
    try {
      const result = await this.get(
        `${this.basePath}/invoice-merges/${poNumber}`,
      );
      return (result?.data as IDeliveryNote) ?? null;
    } catch {
      return null;
    }
  }
}

export const swiperxWmsApiDeliveryNote = new SwipeRxWmsApiDeliveryNote();
